// src/shared/hooks/useVendorAssignedSeasons.ts
import { useMemo } from 'react';
import { accountStore } from 'store/accountStore';
import { useVendorSeasonList } from './useVendorSeasonList';

/**
 * 현재 로그인한 user에게 매핑된 season 목록을 가져옴.
 * /api/v1/vendor/season-list/?user_id=<me>로 서버사이드 필터링.
 */
export const useVendorAssignedSeasonIds = () => {
  const account = accountStore.getAccount();
  const userId = account ? Number(account.id) : undefined;

  const { data, isLoading, isError } = useVendorSeasonList(
    userId ? { user_id: userId, page: 1, page_size: 100 } : undefined,
    { enabled: !!userId }
  );

  const seasonIds = useMemo(() => {
    if (!data?.results) return [];
    return Array.from(new Set(data.results.map(m => m.season)));
  }, [data]);

  return { seasonIds, isLoading: isLoading || !account, isError };
};
